import Cookie from '@component/common/src/util/Cookie';
import { firstWordOccurrence, firstNumberOccurrence } from './StringUtil';

Cookie.formatDomainForCookie = function domainForCookie(host) {
  let domain;
  if (typeof host === 'string' && host.length > 0) {
    if (host.indexOf('.', host.indexOf('.', 0) + 1) > 1) {
      domain = host.indexOf('.', 0) > 0 ? host.substring(host.indexOf('.', 0)) : host;
    } else {
      domain = '';
    }
  } else if (typeof domain === 'undefined' || domain === null) {
    domain = window.location.hostname.replace(/(^m[1]?\.)|(^www[1]?\.)/gi, '');
  }
  // remove port for local testing
  domain = (domain && domain.indexOf(':') !== -1) ? domain.substring(0, domain.indexOf(':')) : domain;

  return domain;
};

export default {

  getStringCookie(name, multiValueCookie) {
    return firstWordOccurrence(Cookie.get(name, multiValueCookie));
  },

  getNumberCookie(name, multiValueCookie) {
    return firstNumberOccurrence(Cookie.get(name, multiValueCookie));
  },

};




// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/src/js/util/CookieUtil.js